import styled from 'styled-components';
import { container, spacing } from '../../../theme';

export const StyledTeamMembers = styled.div`
  text-align: center;
  margin-top: ${spacing('xl3')};
`;

export const StyledTeamMembersInfo = styled.div`
  max-width: ${container('md')};
  margin: auto;
  margin-top: ${spacing('lg')};

  p {
    margin-bottom: 0;
    margin-top: ${spacing('xl')};
    line-height: 1.5;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const StyledTeamMembersList = styled.div`
  margin-top: ${spacing('lg')};

  .slick-track {
    display: flex;
    justify-content: flex-end;
  }

  &.is-centered {
    padding-bottom: 0;

    .slick-track {
      justify-content: center;
    }

    .slick-slide {
      max-width: 20rem;
    }
  }
`;

export const StyledTeamMembersListContainer = styled.div`
  margin-left: -${spacing('md')};
  margin-right: -${spacing('md')};

  @media (min-width: ${container('lg')}) {
    margin-left: calc(-100vw / 2 + ${container('lg')} / 2);
    margin-right: calc(-100vw / 2 + ${container('lg')} / 2);
  }
`;
